import { configurationServiceInstance } from "services/ConfigurationService";

export const getTaxonomyClassTitle = (taxonomyClass: string) => {
  return configurationServiceInstance.getTaxonomyItemByName(taxonomyClass)?.title || taxonomyClass;
}
